<template>
  <div class="flex w-full h-full mx-auto p-6">
    <div class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-64 px-4 overflow-hidden">
      <div class="flex items-center pb-4">
        <h3
          class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider"
        >
          Lista de Usuarios
          <span
            class="rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"
          >{{filteredUserList.length}}</span>
        </h3>
        <button class="border-2 rounded border-gray-700" @click="changeFormOrder">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de usuarios"
        class="w-full appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />
      <div class="w-full">
        <div class="w-full relative">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="status"
            id="status"
            v-model="categoryFilter"
          >
            <option selected value="-1">Todos</option>
            <template v-for="category in userCategories">
              <option :key="category.id" :value="category.id">{{category.name_category}}</option>
            </template>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="w-full flex pt-4 pb-2">
        <button
          v-on:click="statusFilterUser = 'all', filteredUserList, updateSelectRegister()"
          class="w-1/3 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterUser === 'all' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color']"
        >Todos</button>
        <button
          v-on:click="statusFilterUser = 'active', filteredUserList, updateSelectRegister()"
          class="w-1/3 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterUser === 'active' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color']"
        >Activos</button>
        <button
          v-on:click="statusFilterUser = 'inactive', filteredUserList, updateSelectRegister()"
          class="w-1/3 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-r border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterUser === 'inactive' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color']"
        >Inactivos</button>
      </div>
      <div class="h-full overflow-auto">
        <div
          v-for="currentUser in filteredUserList"
          v-on:click="getUser(currentUser)"
          :key="currentUser.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{'bg-secondary-color': currentUser.id === user.id}"
        >
          <img
            :src="currentUser.profile_image"
            @error="loadDefaultImg"
            class="object-cover h-12 w-12 rounded-full"
            v-bind:class="[currentUser.inactive ? 'border-solid border-2 border-danger-color' : 'border-solid border-2 border-primary-color']"
          />
          <div class="flex flex-col ml-2">
            <span
              :class="[currentUser.id === user.id ? 'text-gray-100' : 'text-gray-900']"
              class="group-hover:text-gray-900"
            >{{currentUser.name}} {{currentUser.last_name}}</span>
            <span
              :class="[currentUser.id === user.id ? 'text-gray-300' : 'text-gray-700']"
              class="text-sm group-hover:text-gray-700"
            >{{currentUser.email}}</span>
            <span
              :class="[currentUser.id === user.id ? 'text-gray-300' : 'text-gray-700']"
              class="text-sm group-hover:text-gray-700"
            >{{currentUser.name_category}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 pt-8 pb-6 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center">
          <div class="flex-1 text-right" v-if="user">
            <button
              v-on:click="updateDataModal(user)"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >Editar</button>
            <button
              v-if="user.inactive"
              @click="showingConfirmActive = true;"
              class="bg-transparent hover:bg-secondary-color text-secondary-color font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color hover:border-transparent rounded"
            > Activar
            </button>
            <button
              v-if="!user.inactive"
              @click="showingConfirmInactive = true;"
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-danger-color hover:border-transparent rounded"
            >Desactivar
            </button>
          </div>
        </div>
        <div class="w-full flex flex-wrap items-center" v-if="user">
          <div class="w-1/3 flex items-center justify-center">
            <img
              :src="user.profile_image"
              class="object-cover h-64 w-64 rounded-full"
              v-bind:class="[user.inactive ? 'border-solid border-4 border-danger-color' : 'border-solid border-4 border-primary-color']"
            />
          </div>
          <div class="w-2/3">
            <br>
            <div style="text-align:left">
            <span class="font-bold text-gray-900 ">Información Personal</span>
            </div>
            <div class="w-full">
                <div class="flex items-center pt-2 text-sm">
                  <span class="font-bold text-gray-900">Nombre:</span>
                  <span class="ml-2 text-gray-700">{{user.name}} {{user.last_name}}</span>
                </div>
                <div class="flex items-center pt-2 text-sm">
                  <span class="font-bold text-gray-900">Correo:</span>
                  <span class="ml-2 text-gray-700">{{user.email}}</span>
                </div>
            </div><br>
            <div style="text-align:left">
            <div class="font-bold text-gray-900">Información Extra</div>
            </div>
<!--             <div class="flex items-center pt-2 text-sm">
              <span class="font-bold text-gray-900">¿Fue esta persona ayudada?:</span>
              <span class="ml-2 text-gray-700">{{user.help}}</span>
            </div> -->
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Rol:</span>
              <span class="px-2">{{user.name_category}}</span>
            </div>            
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Edad:</span>
              <span class="px-2">{{user.edad}}</span>
            </div>
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Sexo:</span>
              <span class="px-2">{{user.sexo}}</span>
            </div>
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Nivel Escolar:</span>
              <span class="px-2">{{user.nivel_estudios}}</span>
            </div>            
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Idioma:</span>
              <span class="px-2">{{user.idioma}}</span>
            </div>
            <div class="flex items-center pt-2 text-sm">
              <span class="font-bold">Ocupación:</span>
              <span class="px-2">{{user.ocupacion}}</span>
            </div>
          </div>

        
        <div class="w-full mx-auto">
          <br><br>
          <span class="font-bold text-gray-900 text-lg">Bitácora</span>
          <div class="bg-white shadow-md rounded my-6">
            <input
                type="date"
                v-model="searchByday"
                class="w-1/3 appearance-none border rounded py-2 px-3 mb-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
              />
              <button
                class="bg-transparent hover:bg-cdmx-blue-light text-cdmx-blue-dark text-sm font-semibold hover:text-white py-1 px-2 mx-1 mb-3 border border-cdmx-blue-dark hover:border-transparent rounded"
                @click="clearSelectedDate()"
              >Limpiar</button>
            <br>
            <div>
            <input style="width:500px;padding-left:10px; border: 3px solid #ccc;" type="text" placeholder="Filtrar por módulo, accción u observación" v-model="tableFilter" />
            </div>

            <div style="max-height:600px; overflow:auto ">
              <table class="text-left w-full border-collapse">
                <thead>
                  <tr>
                    <th
                      class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                    >Módulo</th>
                    <th
                      class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                    >Acción</th>
                    <th
                      class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                    >Observación</th>
                    <th
                      class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                        >Fecha
                        <button class="border-2 rounded border-gray-700" @click="changeFormOrderBinnacles">
                          <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 fill-current" viewBox="0 0 24 24">
                            <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" />
                            <path d="M0 0h24v24H0z" fill="none" />
                          </svg>
                        </button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="type in filteredBinnacles">
                    <tr class="hover:bg-gray-200" :key="type.id">
                      <td class="py-4 px-6 border-b border-gray-300">{{type.module}}</td>
                      <td class="py-4 px-6 border-b border-gray-300">{{type.action}}</td>
                      <td v-html="type.observation" class="py-4 px-6 border-b border-gray-300" style="white-space: pre-line;"></td>
                      <td class="py-4 px-6 border-b border-gray-300">{{type.date | moment('DD/MM/YYYY hh:mm a') }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        </div>
      </div>
    </div>

    <user-modal
      :showing="showUserModal"
      @updateUser="updateUser"
      @close="showUserModal = false"
    ></user-modal>

    <alert-dialog :showing="showingConfirmActive">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea activar este usuario?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-secondary-color border-4 font-bold tracking-wider bg-white hover:bg-secondary-color"
          @click="updateActivity()"
        >Activar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-500"
          @click="showingConfirmActive = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirmInactive">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">¿Desea desactivar este usuario?</div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-500"
          @click="updateActivity()"
        >Desactivar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-500"
          @click="showingConfirmInactive = false"
        >Cerrar</button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDesactivation">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Desactivado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDesactivation = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingSuccessActivation">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Activado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessActivation = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>


<script>
import userModal from "./UserModal";
import AlertDialog from "./AlertDialog";
import EventBus from "../event-bus";
import moment from "moment";
import axios from "axios";
import XLSX from 'xlsx';

export default {
  name: "userList",
  data() {
    return {
      chatAlert: null,
      chartList: null,
      showChatModal: false,
      showingConfirmActive: false,
      showingConfirmInactive: false,
      showingSuccessDesactivation: false,
      showingSuccessActivation: false,
      json_fields: {
        Nombre: "name",
        Apellido: "last_name",
        Categoria: "name_category",
        Correo: "email",
        Edad: "age",
        Sexo: "sex",
        Telefono: "phone_number",
        Dirección: "address",
        "Url de perfil": "profile_image",
        ID: "auth_id",
        Dispositivo: "device_id"
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      showUserModal: false,
      selectedIndex: 0,
      userList: [],
      user: null,
      newGuestUser: false,
      search: "",
      searchByday: "",
      statusFilterUser: "all",
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      alerts: [],
      binnacles: [],
      alertFilter: "assigned",
      categoryFilter: "-1",
      userCategories: [],
      formOrder: "upward",
      formOrderBinnacle: "upward",
      tableFilter:""
    };
  },
  components: {
    userModal,
    AlertDialog
  },
  created() {
    let that = this;
  },
  mounted() {
    EventBus.$emit("updateNotification", {});
    this.getUserList();
    this.fetchUserCategories();
  },
  methods: {
    updateSelectRegister(){
      if(this.filteredUserList.length > 0){
        this.getUser(this.filteredUserList[0])
      }
    },

    getUserList: function() {
      this.$root.$emit("showLoading");
      axios
        .get("apidev/users/", this.config)
        .then(response => {
          this.userList = response.data;
          this.userList.forEach(data => {
            if (data.profile_image != null) {
              data.profile_image = "apidev/" + data.profile_image;
              //data.profile_image =
               // "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
            } else {
              data.profile_image =
                "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
            }
          });

          if (this.filteredUserList.length > 0) {
            this.getUser(this.filteredUserList[0]);
          }

          this.$root.$emit("hideLoading");
        })
        .catch(error => {
          this.catchError(error);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    getUser: function(user) {
      this.user = user;
      console.log(this.user)
      this.fetchUserBinnacles(this.user.id)
    },

    updateDataModal: function(user) {
      this.showUserModal = true;
      this.newGuestUser = false;
      EventBus.$emit("editModal", user);
    },

    fetchUserBinnacles:function(user_id) {
      this.axios
        .post("/apidev/bitacoras/list/",
          {
             "user_id": user_id
          },
          this.config
        )
        .then(response => {
          this.binnacles = response.data.binnacles;
          console.log(this.binnacles)
        })
        .catch(error => {
          console.log(error)
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    newDataModal: function() {
      this.showUserModal = true;
      this.newGuestUser = true;
    },

    updateUser: function(select_user) {
      this.userList.forEach(user => {
        if (user.id == select_user.id) {
          let updateUser = Object.assign({}, select_user);
          user.name = updateUser.name;
          user.last_name = updateUser.last_name;
          user.address = updateUser.address;
          user.phone_number = updateUser.phone_number;
          user.age = updateUser.age;
          user.sex = updateUser.sex;
          user.auth_id = updateUser.auth_id;
          user.category_id = updateUser.category_id;
          user.name_category = updateUser.name_category;
          user.profile_image = updateUser.profile_image;
        }
      });
    },

    updateActivity: function() {
      this.$root.$emit("showLoading");
      let nombre_usuario = this.user.name+" "+this.user.last_name;
      if(this.user.inactive) { // usuario inactivo, activar usuario
      this.axios
        .post("apidev/users/inactive/rol", {
          "inactive": "false",
          "email": this.user.email,
          "user_id": this.user.id
        }, this.config)
        .then(response => {
          this.showingConfirmActive = false;

          //guarda bitácora
          let name = localStorage.getItem("name")
        
          //console.log(name+" activó al usuario "+nombre_usuario+"("+this.user.email+")")
          this.axios.post("/apidev/bitacoras/save/",{
              "module": "Usuarios", 
              "action": "Activación de usuario", 
              "observation": name+" activó al usuario "+nombre_usuario+"("+this.user.email+")",
              "email": localStorage.getItem("email"),
              "user_id": localStorage.getItem("user_id")
            },
            this.config
          )
          .then(response => {
            //console.log(response)
          })
          .catch(error => {
            console.log(error)
          });
          //FIN guarda bitácora

          this.$root.$emit("hideLoading");
          this.showingSuccessActivation = true;
          this.getUserList();
        })
        .catch(error => {
          this.catchError(error);
        });
      } else {   // desactivar usuario
        this.axios
        .post("apidev/users/inactive/rol", {
          "inactive": "true",
          "email": this.user.email,
          "user_id": this.user.id
        }, this.config)
        .then(response => {
          this.showingConfirmInactive = false;

          //guarda bitácora
          let name = localStorage.getItem("name")
        
          //console.log(name+" desactivó al usuario "+nombre_usuario+"("+this.user.email+")")
          this.axios.post("/apidev/bitacoras/save/",{
              "module": "Usuarios", 
              "action": "Desctivación de usuario", 
              "observation": name+" desactivó al usuario "+nombre_usuario+"("+this.user.email+")",
              "email": localStorage.getItem("email"),
              "user_id": localStorage.getItem("user_id")
            },
            this.config
          )
          .then(response => {
            //console.log(response)
          })
          .catch(error => {
            console.log(error)
          });
          //FIN guarda bitácora


          this.$root.$emit("hideLoading");
          this.showingSuccessDesactivation = true;
          this.getUserList();
        })
        .catch(error => {
          this.catchError(error);
        });
      }
    },
    fetchUserCategories() {
      this.axios
        .get("apidev/users/categories", this.config)
        .then(response => {
          this.userCategories = response.data.categories;
        })
        .catch(error => {
          this.catchError(error);
        });
    },
    loadDefaultImg(event) {
      event.target.src =
        "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";
    },
    changeFormOrder() {
      if (this.formOrder === "upward") {
        this.formOrder = "downward";
      } else {
        this.formOrder = "upward";
      }
    },
    changeFormOrderBinnacles() {
      if (this.formOrderBinnacle === "upward") {
        this.formOrderBinnacle = "downward";
      } else {
        this.formOrderBinnacle = "upward";
      }
    },    
    clearSelectedDate() {
      this.searchByday = "";
    },
    catchError(error) {
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }

      this.$root.$emit("hideLoading");
    }
  },

  computed: {
    filteredUserList: function() {
      return this.userList
        .filter(user => {
          let full_name = user.name + " " + user.last_name;
          switch (this.statusFilterUser) {
            case "all":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  user.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  user.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                (this.categoryFilter === "-1" ||
                  user.category_id === this.categoryFilter)
              );
            case "active":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  user.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  user.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                !user.inactive &&
                (this.categoryFilter === "-1" ||
                  user.category_id === this.categoryFilter)
              );
            case "inactive":
              return (
                (full_name.toLowerCase().includes(this.search.toLowerCase()) ||
                  user.name_category
                    .toLowerCase()
                    .includes(this.search.toLowerCase()) ||
                  user.email
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                user.inactive &&
                (this.categoryFilter === "-1" ||
                  user.category_id === this.categoryFilter)
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.formOrder === "upward") {
            if(a.name != null && b.name != null){
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
              }
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
              }
            }
            return 0;
          } else {
            if(a.name != null && b.name != null){
              if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return -1;
              }
              if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return 1;
              }
            }
            return 0;
          }
        });
    },

    filteredBinnacles() {
      return this.binnacles.filter(binnacle => {
        let date = moment(binnacle.date).format("YYYY-MM-DD");

        if(this.tableFilter != ""){
          const module = binnacle.module.toString().toLowerCase();
          const action = binnacle.action.toLowerCase();
          const observation = binnacle.observation.toLowerCase();
          const searchTerm = this.tableFilter.toLowerCase();

          return (
            (module.includes(searchTerm) ||  action.includes(searchTerm)  ||  observation.includes(searchTerm)) &&
            date.toLowerCase().includes(this.searchByday.toLowerCase())
          );
        }
        else{
          return date.toLowerCase().includes(this.searchByday.toLowerCase())
        }



      }).sort((a, b) => {
        if (this.formOrderBinnacle === "upward") {
          return new Date(a.date) - new Date(b.date);
        } else {
          return new Date(b.date) - new Date(a.date);
        }
      });
    },    
    filteredAlerts() {
      return this.alerts.filter(alert => {
        let date = moment(alert.fecha_alerta).format("YYYY-MM-DD");

        switch (this.alertFilter) {
          // case "all":
          //   return date.toLowerCase().includes(this.searchByday.toLowerCase());
          case "attended":
            if (alert.status === "ATENDIDA") {
              if (
                this.searchByday === "" ||
                date.toLowerCase().includes(this.searchByday.toLowerCase())
              ) {
                return true;
              } else {
                false;
              }
            } else {
              return false;
            }
          case "assigned":
            if (alert.status === "ASIGNADA") {
              if (
                this.searchByday === "" ||
                date.toLowerCase().includes(this.searchByday.toLowerCase())
              ) {
                return true;
              } else {
                false;
              }
            } else {
              return false;
            }
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
